import React from 'react';

export const IconImageWhite = () => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.83333V12.1667C12 12.3508 11.8508 12.5 11.6667 12.5H2.33333C2.14924 12.5 2 12.3508 2 12.1667V2.83333C2 2.64924 2.14924 2.5 2.33333 2.5H11.6667C11.8508 2.5 12 2.64924 12 2.83333Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 9.72221L5.88889 8.05554L12 10.8333" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.22244 6.38897C8.60877 6.38897 8.11133 5.89151 8.11133 5.27786C8.11133 4.66421 8.60877 4.16675 9.22244 4.16675C9.83611 4.16675 10.3336 4.66421 10.3336 5.27786C10.3336 5.89151 9.83611 6.38897 9.22244 6.38897Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
